import styled from "styled-components";
import Colors from "../../../../../general/constants/colors";
export const SubMenuContainer = styled("div")({
	display: 'none',
	width: "max-content",
	backgroundColor: Colors.WHITE,
	boxShadow: '0px -15px 30px -10px rgba(0,11,48,0.2)',
	position: "absolute",
	bottom: "100%",
	borderRadius: '16px',
	zIndex: 1,
})

export const SubMenuThirdItems = styled("ul")({
	backgroundColor: Colors.GREY_LIGHT_2,
	borderBottomRightRadius: '16px',
	borderTopRightRadius: '16px',
	overflow: "hidden",
	transition: "all .3s ease",
	borderRadius: "unset",
	paddingLeft: "45px",
	marginTop: "5px",
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
})